/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2.00024 4.00018L3.00024 5.00018L6.00024 2.00018M2.00024 12.0002L3.00024 13.0002L6.00024 10.0002M2.00024 20.0002L3.00024 21.0002L6.00024 18.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.0002 20.0002L22.0002 20.0002M11.0002 12.0002L22.0002 12.0002M11.0002 4.00018H22.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M11.0002 20.0002L22.0002 20.0002M11.0002 12.0002L22.0002 12.0002M11.0002 4.00018H22.0002M2.00024 4.00018L3.00024 5.00018L6.00024 2.00018M2.00024 12.0002L3.00024 13.0002L6.00024 10.0002M2.00024 20.0002L3.00024 21.0002L6.00024 18.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M11 20L22 20M11 12L22 12M11 4H22M2 4L3 5L6 2M2 12L3 13L6 10M2 20L3 21L6 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16.0002 20.0002H11.0002M22.0002 20.0002H20.0002M17.0002 12.0002H22.0002H11.0002H13.0002M16.0002 4.00018H11.0002M22.0002 4.00018H20.0002M2.00024 4.00018L3.00024 5.00018L6.00024 2.00018M2.00024 12.0002L3.00024 13.0002L6.00024 10.0002M2.00024 20.0002L3.00024 21.0002L6.00024 18.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M11.0002 20.0002L22.0002 20.0002M11.0002 12.0002L22.0002 12.0002M11.0002 4.00018H22.0002M2.00024 4.00018L3.00024 5.00018L6.00024 2.00018M2.00024 12.0002L3.00024 13.0002L6.00024 10.0002M2.00024 20.0002L3.00024 21.0002L6.00024 18.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M11 20L22 20M11 12L22 12M11 4H22M2 4L3 5L6 2M2 12L3 13L6 10M2 20L3 21L6 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
